import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4502Model } from '../kymw4502.model';

/**
 * 特集コピー実行
 *
 * @export ExecuteFeatureCopyService
 * @class ExecuteFeatureCopyService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class ExecuteFeatureCopyService extends PlessJsonResponderSub<any> {
  private vo = {
    CopyToOrderCode: '',
    CopyFromOrderCode: '',
    selectedMediumTypes: []
  };

  private successFunc: Function;
  private model: KYMW4502Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * @returns {PlessRequest} リクエストJSON
   * @memberof ExecuteFeatureCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        CopyFeatureList: {
          condition: {
            CopyToOrderCode: this.vo.CopyToOrderCode,
            CopyFromOrderCode: this.vo.CopyFromOrderCode
          },
          combination: this.vo.selectedMediumTypes.map(selectedMediumType => {
            return {
              condition: {
                MediumType: selectedMediumType
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   * @param vo 
   * @param successFunc
   * @memberof ExecuteFeatureCopyService
   */
  execute(model: KYMW4502Model, successFunc: Function = null): void {
    this.model = model;
    this.vo.CopyToOrderCode = model.orderCode;
    this.vo.CopyFromOrderCode = model.copiedOrderCode;
    this.vo.CopyFromOrderCode = model.copiedOrderCode;
    this.vo.selectedMediumTypes = model.mediumTypeList.filter(_ => _.checked).map(_ => _.mediumType);
    this.successFunc = successFunc;
    this.send('executeFeatureCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data レスポンスデータ
   * @memberof ExecuteFeatureCopyService
   */
  success(data: any) {
    if (this.successFunc) this.successFunc();
  }
}
